import { atom } from "recoil";

export const createTenantDrawerState = atom({
    key: "createTenantDrawerState", // unique ID (with respect to other atoms/selectors)
    default: null, // default value (aka initial value) 
})